import React, { FC, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/rootReducer';
import { States_US } from '../../util/States';
import withLocalization from '../hoc/withLocalization';
import './PackageSummaryReview.scss';

const ContactInformationReview: FC<any> = (props: any): ReactElement => {
  const { localize } = props;
  const offerDetails = useSelector((state: RootState) => state.offerDetails);
  const prospect = offerDetails.prospect;
  const guestInfo = offerDetails.guests;
  const stateName =
    prospect && prospect.stateProvince
      ? prospect.stateProvince.length > 2
        ? prospect.stateProvince.toLocaleLowerCase()
        : States_US.filter((e) => e.code === prospect.stateProvince)[0].name.toLocaleLowerCase()
      : '';

  return (
    <>
      <div className="packageSummaryReviewDisplay">
        <h5 className="confirmationHeader">
          {localize('preview-sales-engine.static-content.copy.contact-information-page.header')}
        </h5>
        <div className="headingPadding">
          <table>
            <tbody>
              <tr>
                <td className="bolderText">
                  {localize('preview-sales-engine.static-content.copy.Confirmation Page.first-name')}
                </td>
                <td>{prospect?.firstName}</td>
              </tr>
              <tr>
                <td className="bolderText">
                  {localize('preview-sales-engine.static-content.copy.Confirmation Page.last-name')}
                </td>
                <td>{prospect?.lastName}</td>
              </tr>
              <tr>
                <td className="bolderText">
                  {localize('preview-sales-engine.static-content.copy.Labels.labels#souse-partner-first-name')}:
                </td>
                <td>{prospect?.spouseFirstName}</td>
              </tr>
              <tr>
                <td className="bolderText">
                  {localize('preview-sales-engine.static-content.copy.Labels.labels#souse-partner-last-name')}:
                </td>
                <td>{prospect?.spouseLastName}</td>
              </tr>
              <tr>
                <td className="bolderText paddingTop">
                  {localize('preview-sales-engine.static-content.copy.Confirmation Page.street-address')}
                </td>
                <td className="paddingTop">{prospect?.addressLine1}</td>
              </tr>
              <tr>
                <td className="bolderText">
                  {localize('preview-sales-engine.static-content.copy.Confirmation Page.city')}
                </td>
                <td>{prospect?.city}</td>
              </tr>
              <tr>
                <td className="bolderText">
                  {localize('preview-sales-engine.static-content.copy.Confirmation Page.state')}
                </td>
                <td className="capitalize">{stateName}</td>
              </tr>
              <tr>
                <td className="bolderText">
                  {localize('preview-sales-engine.static-content.copy.Confirmation Page.zip-code')}
                </td>
                <td>{prospect?.postalCode}</td>
              </tr>
              <tr>
                <td className="bolderText paddingTop">
                  {localize('preview-sales-engine.static-content.copy.Confirmation Page.email')}
                </td>
                <td className="paddingTop">{prospect?.email}</td>
              </tr>
              <tr>
                <td className="bolderText">
                  {localize('preview-sales-engine.static-content.copy.Confirmation Page.phone')}
                </td>
                <td>{prospect?.phone}</td>
              </tr>
              <tr>
                <td className="bolderText">
                  {localize('preview-sales-engine.static-content.copy.Confirmation Page.adults')}
                </td>
                <td>{guestInfo ? guestInfo.adults : ''}</td>
              </tr>
              <tr>
                <td className="bolderText">
                  {localize('preview-sales-engine.static-content.copy.Confirmation Page.children')}
                </td>
                <td>{guestInfo ? guestInfo.children : ''}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
export default withLocalization(ContactInformationReview);
